// extracted by mini-css-extract-plugin
module.exports = {"icon":"LetterIcon_icon__398U5","small":"LetterIcon_small__3rwSI"};